var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-page',[_c('portal',{attrs:{"to":"app-header-portal"}},[_c('n-app-header',{attrs:{"title":_vm.pageTitle}})],1),(_vm.ready)?_vm._m(0):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('n-container',{staticClass:"text-xs-center",attrs:{"narrow":""}},[_c('n-template-string',{attrs:{"content":_vm.snippet,"data":_vm.templateData}})],1)
}]

export { render, staticRenderFns }